/* eslint-disable prefer-destructuring,func-names,react/prop-types  */
import React from 'react';
import { Alert, Button } from 'antd';
import styled from 'styled-components';
import _ from 'lodash';

import StyledTable from '../../views/StyledTable';
import Clamper from '../../views/ContentWidthClamper';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import ContentHeader from "../../views/ContentHeader";
import PageFrame from '../../views/PageFrame';
import ButtonList from "../../views/ButtonList";

const StyledLastSix = styled.div`
  text-align: left;
  padding-left: 20px;
  font-weight: 600;
  position: relative;
  :before {
    content: "\\02026";
  }
`;

export default (bottle) => {
  bottle.factory('KeyManagerView', ({ keyManagerColumns }) => ({
    title, goHome, onSelect, dataSource, children, onCreateKey, lastError, isLoading,
  }) => (
    <PageFrame className="key-manager-view">
      <Clamper>
        <ContentHeader>
          <HeadlineBreadcrumbList>
            {[
              { onClick: goHome, text: 'Home' },
              title,
            ]}
          </HeadlineBreadcrumbList>
          {!lastError &&
          <ButtonList compact line={false} style={({ flex: 1 })}>
            <Button
              type="primary"
              icon="plus"
              onClick={onCreateKey}
            >
              <span>New</span>
            </Button>
            {children}
          </ButtonList>
          }
          {lastError &&
            <Alert
              message="Error"
              description={`${lastError.message} ${_.get(lastError, 'response.request.response', '???')}`}
              type="error"
            />
          }
        </ContentHeader>
        <StyledTable
          key="key-table"
          rowKey="id"
          columns={keyManagerColumns(StyledLastSix)}
          dataSource={dataSource}
          pagination={false}
          loading={isLoading}
          onSelect={onSelect}
        />
      </Clamper>
    </PageFrame>
  ));
};
